var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box, styled, Button, TextField, InputLabel } from "@mui/material";
import { DropFile, Dialog } from "@sequentech/ui-essentials";
import { FormStyles } from "@/components/styles/FormStyles";
import React, { useEffect, useRef, memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { GET_UPLOAD_URL } from "@/queries/GetUploadUrl";
import { useMutation } from "@apollo/client";
import { SimpleForm, useNotify } from "react-admin";
export var ImportStyles = {
    CancelButton: styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        margin-right: auto;\n        background-color: ", ";\n        color: ", ";\n    "], ["\n        margin-right: auto;\n        background-color: ", ";\n        color: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.palette.grey[100];
    }, function (_a) {
        var theme = _a.theme;
        return theme.palette.brandColor;
    }),
    ImportButton: styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        margin-left: auto;\n    "], ["\n        margin-left: auto;\n    "]))),
};
var PasswordInputStyle = styled(FormStyles.PasswordInput)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex: 1;\n    margin: 0;\n"], ["\n    flex: 1;\n    margin: 0;\n"])));
export var ImportScreenMemo = memo(function (props) {
    var doCancel = props.doCancel, uploadCallback = props.uploadCallback, doImport = props.doImport, disableImport = props.disableImport, refresh = props.refresh, errors = props.errors;
    var t = useTranslation().t;
    var notify = useNotify();
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = React.useState(""), shaField = _b[0], setShaField = _b[1];
    var _c = React.useState(false), showShaDialog = _c[0], setShowShaDialog = _c[1];
    var _d = React.useState(false), isUploading = _d[0], setIsUploading = _d[1];
    var _e = React.useState(null), documentId = _e[0], setDocumentId = _e[1];
    var getUploadUrl = useMutation(GET_UPLOAD_URL)[0];
    var _f = useState(false), isEncrypted = _f[0], setIsEncrypted = _f[1];
    var _g = useState(false), passwordDialogOpen = _g[0], setPasswordDialogOpen = _g[1];
    var passwordInputRef = useRef(null);
    var _h = useState(""), password = _h[0], setPassword = _h[1];
    var _j = useState(), theFile = _j[0], setTheFile = _j[1];
    useEffect(function () {
        setShaField("");
        setDocumentId(null);
    }, [refresh]);
    // Used to autofocus the password input field in the modal dialog. Just
    // using the autofocus property in PasswordInputStyle's inputProps
    // doesn't work
    useEffect(function () {
        if (passwordDialogOpen && (passwordInputRef === null || passwordInputRef === void 0 ? void 0 : passwordInputRef.current)) {
            passwordInputRef.current.focus();
        }
    }, [passwordDialogOpen, passwordInputRef.current]);
    var uploadFile = function (url, file) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, {
                        method: "PUT",
                        headers: {
                            "Content-Type": file.type,
                        },
                        body: file,
                    })];
                case 1:
                    _a.sent();
                    setIsUploading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var uploadFileToS3 = function (theFile) { return __awaiter(void 0, void 0, void 0, function () {
        var data, _error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, getUploadUrl({
                            variables: {
                                name: theFile.name,
                                media_type: isEncrypted ? "application/ezip" : theFile.type,
                                size: theFile.size,
                                is_public: false,
                            },
                        })];
                case 1:
                    data = (_b.sent()).data;
                    if (!((_a = data === null || data === void 0 ? void 0 : data.get_upload_url) === null || _a === void 0 ? void 0 : _a.url)) {
                        notify(t("electionEventScreen.import.fileUploadError"), { type: "error" });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, uploadFile(data.get_upload_url.url, theFile)];
                case 2:
                    _b.sent();
                    setDocumentId(data.get_upload_url.document_id);
                    if (!uploadCallback) return [3 /*break*/, 4];
                    console.log("uploadCallback call");
                    return [4 /*yield*/, (uploadCallback === null || uploadCallback === void 0 ? void 0 : uploadCallback(data.get_upload_url.document_id, password, shaField))];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    notify(t("electionEventScreen.import.fileUploadSuccess"), { type: "success" });
                    return [3 /*break*/, 6];
                case 5:
                    _error_1 = _b.sent();
                    setIsUploading(false);
                    notify(t("electionEventScreen.import.fileUploadError"), { type: "error" });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleFiles = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var theFile, isEncrypted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // https://fullstackdojo.medium.com/s3-upload-with-presigned-url-react-and-nodejs-b77f348d54cc
                    setPassword("");
                    theFile = files === null || files === void 0 ? void 0 : files[0];
                    setTheFile(theFile);
                    isEncrypted = (theFile === null || theFile === void 0 ? void 0 : theFile.name.endsWith(".ezip")) || false;
                    setIsEncrypted(isEncrypted);
                    if (isEncrypted) {
                        setPasswordDialogOpen(true);
                        return [2 /*return*/];
                    }
                    if (!theFile) return [3 /*break*/, 2];
                    setIsUploading(true);
                    return [4 /*yield*/, uploadFileToS3(theFile)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    setIsUploading(false);
                    notify(t("electionEventScreen.import.fileUploadError"), { type: "error" });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handlePasswordSubmit = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPasswordDialogOpen(false);
                    if (!theFile || !value) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, uploadFileToS3(theFile)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onImportButtonClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shaField) {
                        setShowShaDialog(true);
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    return [4 /*yield*/, doImport(documentId, shaField, password)];
                case 1:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var isWorking = function () { return loading || isUploading; };
    return (_jsxs(Box, { sx: { padding: "0" }, children: [_jsx(TextField, { disabled: isWorking(), label: String(t("electionEventScreen.import.sha")), size: "small", value: shaField, onChange: function (e) {
                    return setShaField(e.target.value);
                } }), _jsx(DropFile, { handleFiles: function (files) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                    return [2 /*return*/, handleFiles(files)];
                }); }); } }), _jsxs(FormStyles.StatusBox, { children: [isWorking() ? _jsx(FormStyles.ShowProgress, {}) : null, errors ? (_jsx(FormStyles.ErrorMessage, { variant: "body2", children: errors })) : null] }), _jsxs(Box, { sx: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "16px",
                }, children: [_jsx(ImportStyles.CancelButton, { disabled: isWorking(), onClick: function () { return doCancel(); }, children: t("electionEventScreen.import.cancel") }), _jsx(ImportStyles.ImportButton, { disabled: !documentId || isWorking() || disableImport || showShaDialog, onClick: onImportButtonClick, children: t("electionEventScreen.import.import") })] }), _jsx(Dialog, { variant: "warning", open: showShaDialog, ok: String(t("electionEventScreen.import.shaDialog.ok")), cancel: String(t("electionEventScreen.import.shaDialog.cancel")), title: String(t("electionEventScreen.import.shaDialog.title")), handleClose: function (result) {
                    if (result) {
                        doImport(documentId, shaField, password);
                    }
                    setShowShaDialog(false);
                }, children: t("electionEventScreen.import.shaDialog.description") }), _jsx(Dialog, { open: passwordDialogOpen, handleClose: handlePasswordSubmit, title: String(t("electionEventScreen.import.passwordDialog.title")), ok: "Ok", variant: "info", children: _jsx(_Fragment, { children: _jsx(SimpleForm, { toolbar: false, component: Box, children: _jsxs(Box, { children: [_jsxs(InputLabel, { children: [t("electionEventScreen.import.passwordDialog.description"), ":"] }), _jsx(PasswordInputStyle, { label: false, source: "password", helperText: false, onChange: function (e) { return setPassword(e.target.value); }, inputProps: {
                                        ref: passwordInputRef,
                                    } })] }) }) }) })] }));
});
ImportScreenMemo.displayName = "ImportScreen";
export var ImportScreen = ImportScreenMemo;
var templateObject_1, templateObject_2, templateObject_3;
